<template>
  <div class="count-wrapper">
    <div class="count" :class="size">
      <slot :count="countDown">
        <span class="number">{{ countDown.endH }}</span>
        <i class="interval">:</i>
        <span class="number">{{ countDown.endM }}</span>
        <i class="interval">:</i>
        <span class="number">{{ countDown.endS }}</span>
      </slot>
    </div>
  </div>
</template>

<script>
import { CountDown } from '@/utils/countDown.js'
export default {
  props: {
    time: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'small'
    },
    bgColor: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      countDown: {
        endH: '00',
        endM: '00',
        endS: '00'
      }
    }
  },
  mounted() {
    this.countDownInstance = new CountDown()
    if (this.time) {
      this.countDownInstance.start({
        countDownTime: this.time * 1000,
        onUpdate: ({ h, m, s, countDownTime }) => {
          this.countDown.endH = h
          this.countDown.endM = m
          this.countDown.endS = s
          if (countDownTime <= 0) {
            this.countDownInstance.stop()
            this.$emit('down')
          }
        }
      })
    }
  },
  activated() {
    this.countDownInstance.start()
  },
  deactivated() {
    this.countDownInstance.stop()
  },
  destroyed() {
    this.countDownInstance.stop()
  }
}
</script>

<style lang="scss" scoped>
.count {
  display: flex;

  align-items: center;
  .number {
    display: flex;

    border-radius: 2px;

    justify-content: center;
    align-items: center;

    font-size: 0.2rem;
  }
  .interval {
    margin: 0 0.08rem;

    font-size: 0.2rem;
    font-style: normal;

    color: #ff4a28;
  }
  &.small {
    .number {
      width: 0.32rem;
      height: 0.32rem;

      background-color: #ff4a28;

      color: #fff;
    }
  }
  &.large {
    .number {
      width: 0.44rem;
      height: 0.44rem;

      background-color: #fff;

      color: #ff4a28;
    }
    .interval {
      margin: 0 0.08rem;

      font-size: 0.2rem;
      font-style: normal;

      color: #fff;
    }
  }
}
</style>
